import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetContentDescription,
  ModalSheetContentIllustration,
  ModalSheetContentTitle,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
} from '@/components/ModalSheet'
import { Button } from '@/components/Button'
import { byDesign } from '@/infra/design'
import imgMilestoneUrl from '@/assets/misc/img_milestone.svg'
import RatingsAltIllustration from '@/components/SpotIllustration/RatingsAltIllustration'

export interface BulkCopyJobsSuccessDialogProps {
  showing: boolean
  jobCount: number
  onClose: () => unknown
  onStart: () => unknown
}

export function BulkCopyJobsSuccessDialog({
  showing,
  jobCount,
  onClose,
  onStart,
}: BulkCopyJobsSuccessDialogProps) {
  return (
    <ModalSheet showing={showing} onRequestClose={onClose}>
      <ModalSheetHeader withCloseButton />
      <ModalSheetContent>
        <ModalSheetContentBlock>
          <ModalSheetContentIllustration
            src={imgMilestoneUrl}
            illustration={byDesign(undefined, RatingsAltIllustration)}
            alt="Clone Jobs"
          />
          <ModalSheetContentTitle>
            {jobCount} Jobs were successfully cloned!
          </ModalSheetContentTitle>
          <ModalSheetContentDescription>
            You can now edit Legend's responses
          </ModalSheetContentDescription>
        </ModalSheetContentBlock>
      </ModalSheetContent>
      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button label="Close" onPress={onClose} />
          <Button
            label="Start"
            onPress={onStart}
            variant="primary"
            testId="bulk-copy-jobs-success-modal-confirm"
          />
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
}
